import { useRouteRef } from '@backstage/frontend-plugin-api';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import {
  entityRouteParams,
  entityRouteRef,
} from '@backstage/plugin-catalog-react';
import type { Entity } from '@backstage/catalog-model';

export const useTechDocsLink = (entity: Entity | null) => {
  const toTechDocsReader = useRouteRef(techdocsPlugin.routes.docRoot);

  if (!entity) {
    return { baseUrl: '', techDocsLink: () => '' };
  }

  const { namespace, kind, name } = entityRouteParams(entity);

  const baseUrl = toTechDocsReader
    ? toTechDocsReader({ namespace, kind, name })
    : '';

  const linkTo = (relativePath = '') => {
    const fullPath = relativePath
      ? `${baseUrl}/${relativePath.replace(/^\/+/, '')}`
      : baseUrl;
    return fullPath.replaceAll(/\/{2,}/g, '/');
  };

  return { baseUrl, techDocsLink: linkTo };
};

export const useEntityRoute = (entity: Entity) => {
  const catalogRouteRef = useRouteRef(entityRouteRef);

  const entityRoute = catalogRouteRef
    ? catalogRouteRef(entityRouteParams(entity))
    : '';

  return { entityRoute };
};
